import { chartColor } from '../shared/TimeSeriesChart';

// The Accounts screens' tints, the Dashboard's: good news on green, bad news
// on red, a warning on amber, nothing to say on the card fill. A change is
// toned by whether it is good news, not by its direction: less debt is good.
export const TONE = {
  good: { color: 'redesign.amount.income', bg: 'rgba(21, 128, 61, 0.10)', _dark: { bg: 'rgba(74, 222, 128, 0.14)' } },
  bad: { color: 'redesign.accent.red', bg: 'rgba(185, 28, 28, 0.08)', _dark: { bg: 'rgba(248, 113, 113, 0.14)' } },
  warn: { color: 'redesign.text.warn', bg: 'rgba(180, 83, 9, 0.12)', _dark: { bg: 'rgba(250, 204, 21, 0.14)' } },
  neutral: { color: 'redesign.text.muted', bg: 'redesign.bg.card' },
};

// The same reading for a sparkline, which needs a CSS value.
export const LINE_TONE = {
  good: chartColor('redesign.accent.green'),
  bad: chartColor('redesign.accent.red'),
  neutral: chartColor('redesign.text.muted'),
};

// `good` is true, false, or null when there is no change to speak of.
export const toneOf = (good) => (good == null ? 'neutral' : good ? 'good' : 'bad');
